import moment from "moment";


export const formatDate = (date) => {
    return date ? moment(date).format('DD.MM.YYYY') : null
};
export const formatDateTime = (date) => {
  return date ? moment(date).format('DD.MM.YYYY H:m') : null
};
export const formatDecimals = (value, decimals) => {
  return value ? value.toFixed(decimals) : 0;
}

export default {
  formatDate,
  formatDecimals,
  formatDateTime
};
